export const times = [
  {
    id: 'morning',
    value: 'Manhã',
    desc: 'Nenhuma alteração.',
    img: '/assets/img/game_resources/horarios/manha.jpg'
  },

  {
    id: 'afternoon',
    value: 'Tarde',
    desc:
      'Diminui todos os atributos de personagens das raças: Vampiro, Lobisomem, Zumbi, Demônio e Fantasma em 1 ponto. Aumenta todos os atributos de personagens das raças: Anjo e Fada em 1 ponto.',
    img: '/assets/img/game_resources/horarios/tarde.jpg'
  },

  {
    id: 'night',
    value: 'Noite',
    desc:
      'Diminui todos os atributos de personagens das raças: Anjo e Fada em 1 ponto. Aumenta todos os atributos de personagens das raças: Vampiro, Lobisomem, Zumbi, Demônio e Fantasma em 1 ponto.',
    img: '/assets/img/game_resources/horarios/noite.jpg'
  }
]

export const weathers = [
  {
    id: 'cloud',
    value: 'Nublado',
    desc: 'Nenhuma alteração.',
    img: '/assets/img/game_resources/climas/nublado.jpg'
  },

  {
    id: 'sun',
    value: 'Céu Limpo',
    desc:
      'Diminui todos os atributos de personagens das raças: Vampiro, Lobisomem, Zumbi, Demônio e Fantasma em 1 ponto. Aumenta todos os atributos de personagens das raças: Anjo e Fada em 1 ponto.',
    img: '/assets/img/game_resources/climas/ceu_limpo.jpg'
  },

  {
    id: 'rain',
    value: 'Chuva',
    desc: 'Mov - 1 de personagens das raças: Anjo, Demônio, Fada e Harpia.',
    img: '/assets/img/game_resources/climas/chuva.jpg'
  },

  {
    id: 'fog',
    value: 'Nevoeiro',
    desc:
      'Diminui todos os atributos de personagens das raças: Anjo e Fada em 1 ponto. Aumenta todos os atributos de personagens das raças: Vampiro, Lobisomem, Zumbi, Demônio e Fantasma em 1 ponto.',
    img: '/assets/img/game_resources/climas/nevoeiro.jpg'
  },

  {
    id: 'snow',
    value: 'Neve',
    desc:
      'Mov - 1 para todos os personagens. No início do turno de cada personagem joga 1d6, se o resultado for 1 o personagem fica congelado essa rodada.',
    img: '/assets/img/game_resources/climas/neve.jpg'
  }
]

export const areas = [
  {
    id: 'forest',
    value: 'Floresta',
    desc:
      'Terreno favorito de criaturas pequenas. Personagens das raças Gnomo, Ninfa e Fada: Defesa + 2. Para personagens das raças: Anjo, Demônio e Harpia gastam 2 pontos de movimento por quadrado.',
    img: '/assets/img/game_resources/terrenos/floresta.jpg'
  },

  {
    id: 'water_shallow',
    value: 'Água Rasa',
    desc:
      'Gasta dois pontos de movimento por quadrado. Não afeta personagens das raças: Demônio, Fada, Anjo, Harpia, Orc, Centauro, Lobisomem, Tritão, Ninfa, Nagah, Fantasma e Gigante.',
    img: '/assets/img/game_resources/terrenos/agua_rasa.jpg'
  },

  {
    id: 'water_medium',
    value: 'Água Mediana',
    desc:
      'Personagens das raças: Gnomo e Anão não conseguem atravessar. Personagens das raças: Orc, Centauro e Lobisomem gastam dois pontos de movimento por quadrado. Personagens das raças: Demônio, Fada, Anjo, Tritão, Ninfa, Harpia, Nagah, Fantasma e Gigante não são afetados. Outros personagens gastam três pontos de movimento por quadrado.',
    img: '/assets/img/game_resources/terrenos/agua_mediana.jpg'
  },

  {
    id: 'water_deep',
    value: 'Água Profunda',
    desc:
      'Personagens não conseguem atravessar. Não afeta personagens das raças: Demônio, Fada, Anjo, Harpia, Tritão, Ninfa, Nagah, Fantasma e Gigante.',
    img: '/assets/img/game_resources/terrenos/agua_profunda.jpg'
  },

  {
    id: 'grass',
    value: 'Planície',
    desc: 'Terreno mais comum, nenhuma alteração.',
    img: '/assets/img/game_resources/terrenos/planicie.jpg'
  },

  {
    id: 'sand',
    value: 'Deserto',
    desc:
      'Terreno de difícil locomoção, gastando dois pontos de movimento por quadrado. Não afeta personagens das raças: Demônio, Fada, Harpia, Nagah, Fantasma e Anjo.',
    img: '/assets/img/game_resources/terrenos/deserto.jpg'
  },

  {
    id: 'swamp',
    value: 'Pântano',
    desc:
      'Terreno de difícil locomoção e que apresenta perigos para os que passam por ele. Gasta dois pontos de movimento por quadrado. Não afeta personagens das raças: Demônio, Fada, Anjo, Nagah, Fantasma, Harpia e Zumbi). Para cada quadrado que locomover joga 1d6, se o resultado for 1 ou 2 o personagem fica envenenado por 2 rodadas. O efeito de envenenamento não afeta personagens da raça: Nagah, Fantasma e Zumbi.',
    img: '/assets/img/game_resources/terrenos/pantano.jpg'
  },

  {
    id: 'mountain',
    value: 'Montanha',
    desc:
      'Terreno de elevadas altitudes que impedem a travessia da maioria das raças. Personagens não conseguem atravessar. Não afeta personagens das raças: Demônio, Fada, Harpia, Fantasma e Anjo. Personagens da raça Gigante quando estiverem em um quadrado adjacente ao de uma Montanha podem gastar um ataque e destruir a Montanha tornando o terreno em um campo neutro (sem efeitos).',
    img: '/assets/img/game_resources/terrenos/montanha.jpg'
  }
]
